import { Select, Button, Slider, Space, Typography, Divider } from 'antd';
import { PlayCircleOutlined, PauseCircleOutlined, StopOutlined } from '@ant-design/icons';
import { useState, useEffect, useCallback } from 'react';
import useSceneStore from '../../stores/sceneStore';
import type { ModelViewerHandle } from './ModelViewer';

const { Text } = Typography;

interface AnimationPanelProps {
  handle: ModelViewerHandle | null;
}

export default function AnimationPanel({ handle }: AnimationPanelProps) {
  const { animation, setAnimation, selectedModelId } = useSceneStore();
  const [names, setNames] = useState<string[]>([]);

  useEffect(() => {
    if (handle?.animations) {
      setNames(handle.animations.names);
      if (handle.animations.names.length > 0 && !animation.clipName) {
        setAnimation({ clipName: handle.animations.names[0] });
      }
    } else {
      setNames([]);
    }
  }, [handle, selectedModelId]);

  const handlePlay = useCallback(() => {
    if (!handle?.animations || !animation.clipName) return;
    handle.animations.setSpeed(animation.clipName, animation.speed);
    handle.animations.play(animation.clipName);
    setAnimation({ isPlaying: true });
  }, [handle, animation.clipName, animation.speed, setAnimation]);

  const handlePause = useCallback(() => {
    if (!handle?.animations || !animation.clipName) return;
    handle.animations.pause(animation.clipName);
    setAnimation({ isPlaying: false });
  }, [handle, animation.clipName, setAnimation]);

  const handleStop = useCallback(() => {
    if (!handle?.animations || !animation.clipName) return;
    handle.animations.stop(animation.clipName);
    setAnimation({ isPlaying: false, clipName: null });
  }, [handle, animation.clipName, setAnimation]);

  if (names.length === 0) return null;

  return (
    <div>
      <Divider style={{ margin: '8px 0' }} />
      <Text strong style={{ fontSize: 13 }}>模型动画</Text>
      <Divider style={{ margin: '8px 0' }} />

      <Space orientation="vertical" style={{ width: '100%' }} size="small">
        <Select
          size="small"
          style={{ width: '100%' }}
          value={animation.clipName}
          onChange={(v) => setAnimation({ clipName: v })}
          options={names.map((n) => ({ value: n, label: n }))}
        />

        <Space>
          <Button size="small" type="primary" icon={<PlayCircleOutlined />} onClick={handlePlay} />
          <Button size="small" icon={<PauseCircleOutlined />} onClick={handlePause} />
          <Button size="small" icon={<StopOutlined />} onClick={handleStop} />
        </Space>

        <div>
          <Text style={{ fontSize: 11, color: '#999' }}>速度: {animation.speed.toFixed(1)}x</Text>
          <Slider min={0} max={5} step={0.1} value={animation.speed}
            onChange={(v) => setAnimation({ speed: v })} />
        </div>
      </Space>
    </div>
  );
}
